var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSearchMentorings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.22,
    height: 104.845,
    viewBox: "0 0 118.22 104.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M4.272,75.5c-.461-.474-.692-1.166-1.239-1.542-1.141-.777-2.04.158-2.356,1.275l-.389-.17C-.767,79.186,1.321,83.57,2.56,87.48c1.542,4.857,3.291,9.6,5.063,14.377,1.153,3.108,5.731,4.347,7.528.984a202.185,202.185,0,0,1,12.033-19.6,3.019,3.019,0,0,0,.388-2.744c.146-.267.376-.5.413-.716L28,79.721v-.036a3.14,3.14,0,0,0,.012-1.676,2.092,2.092,0,0,0-.206-.546,2.7,2.7,0,0,0-.741-1.141,2.624,2.624,0,0,0-1.141-.741,2.678,2.678,0,0,0-1.372-.3l-.959.121a2.635,2.635,0,0,0-1.2.644,2.6,2.6,0,0,0-.923,1,1.321,1.321,0,0,0-.061.206,2.366,2.366,0,0,0-.631.571,2.452,2.452,0,0,0-.607,1.166l-.061.206a20.38,20.38,0,0,0-2.926,2.271A116.533,116.533,0,0,1,23.469,60.9a95.474,95.474,0,0,1,21.7-31.364C63.83,11.687,91.32,1.524,117.123,3.163c1.506.1,1.421-2.088,0-2.271-28.158-3.7-56,4.128-77.274,23.325C24.489,38.072,12.456,58.86,10.027,80.1A15.53,15.53,0,0,0,4.272,75.5Z",
    transform: "translate(118.22 104.845) rotate(180)",
    fill: "#6147cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSearchMentorings);
export default __webpack_public_path__ + "static/media/arrowSearchMentorings.ca9952829e313b621ace4f0f89d734f4.svg";
export { ForwardRef as ReactComponent };